import { Refresh } from '@mui/icons-material';
import { Button, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

const RefreshButton = ({ onClick }) => {
  const { t } = useTranslation('global');
  const theme = useTheme();
  const mediumScreen = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Button
      variant="contained"
      size="small"
      onClick={onClick}
      sx={{
        [theme.breakpoints.down('md')]: {
          p: 0.5,
          minWidth: 0,
        },

        fontWeight: 400,
        color: 'rgba(0, 0, 0, 0.87)',
        backgroundColor: theme.palette.grey[300],
        ':hover': { backgroundColor: theme.palette.grey[200] },
      }}
      startIcon={mediumScreen ? <Refresh /> : undefined}
    >
      {mediumScreen ? t('refresh') : <Refresh />}
    </Button>
  );
};

export default RefreshButton;
